import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import Doses from '@/icons/Doses.vue';
import Attention from '@/icons/Attention.vue';
import ItemIcon from '@/icons/ItemIcon.vue';
import Share from '@/icons/Share.vue';
import Interactions from '@/icons/Interactions.vue';
import UserIcon from '@/icons/UserIcon.vue';
import DdxIcon from '@/icons/DdxIcon.vue';
import DrugsInteractionsIcon from '@/icons/DrugsInteractionsIcon.vue';
import AlgorithmsIcon from '@/icons/AlgorithmsIcon.vue';
import DiseasesIcon from '@/icons/DiseasesIcon.vue';
import ClinicalPatologyIcon from '@/icons/ClinicalPatologyIcon.vue';
import DrugsIcon from '@/icons/DrugsIcon.vue';
import CalculatorsIcon from '@/icons/CalculatorsIcon.vue';
import OralHygieneIcon from '@/icons/OralHygieneIcon.vue';
import FoodsIcon from '@/icons/FoodsIcon.vue';
import SupplementsIcon from '@/icons/SupplementsIcon.vue';
import MagnifyIcon from '@/icons/MagnifyIcon.vue';
import ClockIcon from '@/icons/ClockIcon.vue';
import HistoryIcon from '@/icons/HistoryIcon.vue';
import CalculatorBtnIcon from '@/icons/CalculatorBtnIcon.vue';
import ReferencesInfoIcon from '@/icons/ReferencesInfoIcon.vue';
import FlashcardsIcon from '@/icons/FlashcardsIcon.vue';
import PencilIcon from '@/icons/PencilIcon.vue';
import Drop from '@/icons/Drop.vue';
import AccountIcon from '@/icons/AccountIcon.vue';
import TermsIcon from '@/icons/TermsIcon.vue';
import ProIcon from '@/icons/ProIcon.vue';
import SupportIcon from '@/icons/SupportIcon.vue';
import AboutIcon from '@/icons/AboutIcon.vue';
import RightArrowIcon from '@/icons/RightArrowIcon.vue';
import LeftArrowIcon from '@/icons/LeftArrowIcon.vue';
import TreatmentIcon from '@/icons/TreatmentIcon.vue';
import MenuBurguerIcon from '@/icons/MenuBurguerIcon.vue';
import DiseasesRaisedIcon from '@/icons/DiseasesRaisedIcon.vue';
import DermatologicIcon from '@/icons/DermatologicIcon.vue';
import VaccinesIcon from '@/icons/VaccinesIcon.vue';
import OphtalmicIcon from '@/icons/OphtalmicIcon.vue';
import FavoritesIcon from '@/icons/FavoritesIcon.vue';
import HandoutsIcon from '@/icons/HandoutsIcon.vue';
import HighlightsIcon from '@/icons/HighlightsIcon.vue';
import ForYouIcon from '@/icons/ForYouIcon.vue';
import ContentIcon from '@/icons/ContentIcon.vue';
import ToolsIcon from '@/icons/ToolsIcon.vue';
import DragIcon from '@/icons/DragIcon.vue';
import WhatsappIcon from '@/icons/WhatsappIcon.vue';
import AIIcon from '@/icons/AIIcon.vue';
import "@mdi/js";
import pt from 'vuetify/es5/locale/pt';

Vue.use(Vuetify);
//193153
export default new Vuetify({
  lang: {
    locales: { pt },
    current: 'pt', // Set your current language here
  },
  theme: {
    themes: {
      light: {
        primary: '#193153',
        secondary: "#F5F6FA"
      }
    }
  }, icons: {
    iconfont: 'mdiSvg',
    values: {
      doses: { component: Doses },
      drop: { component: Drop },
      attention: { component: Attention },
      item: { component: ItemIcon },
      share: { component: Share },
      interactions: { component: Interactions },
      user: { component: UserIcon },
      ddx: { component: DdxIcon },
      drugsInteractions: { component: DrugsInteractionsIcon },
      algorithms: { component: AlgorithmsIcon },
      diseases: { component: DiseasesIcon },
      clinicalPatology: { component: ClinicalPatologyIcon },
      drugs: { component: DrugsIcon },
      calculators: { component: CalculatorsIcon },
      oralHygiene: { component: OralHygieneIcon },
      foods: { component: FoodsIcon },
      supplements: { component: SupplementsIcon },
      magnify: { component: MagnifyIcon },
      clock: { component: ClockIcon },
      history: { component: HistoryIcon },
      calculatorBtn: { component: CalculatorBtnIcon },
      referencesInfoIcon: { component: ReferencesInfoIcon },
      flashcardsIcon: { component: FlashcardsIcon },
      pencil: { component: PencilIcon },
      account: { component: AccountIcon },
      terms: { component: TermsIcon },
      pro: { component: ProIcon },
      support: { component: SupportIcon },
      about: { component: AboutIcon },
      rightArrow: { component: RightArrowIcon },
      leftArrow: { component: LeftArrowIcon },
      treatment: { component: TreatmentIcon },
      menuBurguer: { component: MenuBurguerIcon },
      diseasesRaised: { component: DiseasesRaisedIcon },
      dermatologic: { component: DermatologicIcon },
      vaccines: { component: VaccinesIcon },
      ophtalmic: { component: OphtalmicIcon },
      favoritesIcon: { component: FavoritesIcon },
      handouts: { component: HandoutsIcon },
      highlights: { component: HighlightsIcon },
      forYou: { component: ForYouIcon },
      content: { component: ContentIcon },
      tools: { component: ToolsIcon },
      drag: { component: DragIcon },
      whatsapp: { component: WhatsappIcon },
      ai: { component: AIIcon }
    }
  }
});
